import axios from 'axios';
import { API_PATH } from 'config';
import { getAccessTokenApi } from 'api/auth';

const authHeaders = () => ({ Authorization: getAccessTokenApi() });

/** Obtiene el estado de salud de todos los componentes de un ascensor. */
export async function getComponentsHealth(equipoId) {
  const { data } = await axios.get(
    `${API_PATH}/ascensores/${equipoId}/components-health`,
    { headers: authHeaders() }
  );
  return data; // { health: [...] }
}

/** Activa o desactiva el ACK de alerta de salud de un componente. */
export async function setComponentAck(equipoId, nodeId, on) {
  const { data } = await axios.patch(
    `${API_PATH}/ascensores/${equipoId}/components/${nodeId}/health/ack`,
    { on },
    { headers: authHeaders() }
  );
  return data;
}

/**
 * Establece (o limpia si state es null) un override manual del estado de salud
 * de un componente. Permite forzar un estado con nota y fecha de expiración.
 */
export async function setComponentOverride(equipoId, nodeId, { state, note, expires_at }) {
  const { data } = await axios.patch(
    `${API_PATH}/ascensores/${equipoId}/components/${nodeId}/health/override`,
    { state, note, expires_at },
    { headers: authHeaders() }
  );
  return data;
}

/** Obtiene el historial de cambios de estado de salud de un componente. */
export async function getComponentHealthLog(equipoId, nodeId) {
  const { data } = await axios.get(
    `${API_PATH}/ascensores/${equipoId}/components/${nodeId}/health/log`,
    { headers: authHeaders() }
  );
  return data; // { log: [...] }
}
